import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { OwnershipLevel } from '@fitness-force/enum';
import { AppErrors, BadRequestError, NotFoundError } from '@fitness-force/models';;
import type { CreateWhatsappTemplate, ListWhatsAppTemplateMaster, ListWhatsAppTemplateMasterResponse, UpdateWhatsAppTemplate, WhatsAppTemplateMaster } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { map, catchError, throwError, Observable } from 'rxjs';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root'
})
export class WhatsappTemplateMasterService {
  private http = inject(HttpClient);
  private router = inject(Router);

  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  ListWhatsAppSTemplateMaster(tenantId: number): Observable<ListWhatsAppTemplateMasterResponse> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_WHATSAPP_TEMPLATES
      .replace('{tenant_id}', tenantId.toString());
    return this.http.get<ListWhatsAppTemplateMasterResponse>(
        url,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  WhatsAppTemplateMaster(tenantId: number, notificationId:number, templateId:number): Observable<WhatsAppTemplateMaster> {
    return this.http.get<WhatsAppTemplateMaster>(
        environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_WHATSAPP_TEMPLATE_BY_NOTIFICATION
          .replace('{tenant_id}', tenantId.toString())
          .replace('{notification_id}', notificationId.toString())
          .replace('{template_id}', templateId.toString()),
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  GetWhatsAppTemplateMaster(tenantId: number, templateId:number): Observable<WhatsAppTemplateMaster> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_WHATSAPP_TEMPLATE_BY_ID
      .replace('{tenant_id}', tenantId.toString())
      .replace('{template_id}', templateId.toString());
    return this.http.get<WhatsAppTemplateMaster>(
        url,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  
  UpdateWhatsappTemplateMasterStatusActiveByOwnership(ownership:OwnershipLevel, tenantId: number, franchiseGroupId: number, templateId:number): Observable<any> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_COMPANY_WHATSAPP_TEMPLATE_ACTIVE
          .replace('{template_id}', templateId.toString());
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_FRANCHISE_WHATSAPP_TEMPLATE_ACTIVE
          .replace('{franchise_group_id}', franchiseGroupId.toString())
          .replace('{template_id}', templateId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_WHATSAPP_TEMPLATE_ACTIVE
          .replace('{tenant_id}', tenantId.toString())
          .replace('{template_id}', templateId.toString());
        break;
      default:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_WHATSAPP_TEMPLATE_ACTIVE
          .replace('{tenant_id}', tenantId.toString())
          .replace('{template_id}', templateId.toString());
        break;
    }
    return this.http.post<any>(
        url,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  UpdateWhatsappTemplateMasterStatusInActiveByOwnership(ownership:OwnershipLevel, tenantId: number, franchiseGroupId:number, templateId:number): Observable<any> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_COMPANY_WHATSAPP_TEMPLATE_INACTIVE
          .replace('{template_id}', templateId.toString());
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_FRANCHISE_WHATSAPP_TEMPLATE_INACTIVE
          .replace('{franchise_group_id}', franchiseGroupId.toString())
          .replace('{template_id}', templateId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_WHATSAPP_TEMPLATE_INACTIVE
          .replace('{tenant_id}', tenantId.toString())
          .replace('{template_id}', templateId.toString());
        break;
      default:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_WHATSAPP_TEMPLATE_INACTIVE
          .replace('{tenant_id}', tenantId.toString())
          .replace('{template_id}', templateId.toString());
        break;
    }
    return this.http.post<any>(
        url,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  UpdateWhatsappTemplateMasterStatusActive(tenantId: number, templateId:number): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_WHATSAPP_TEMPLATE_ACTIVE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{template_id}', templateId.toString());
    return this.http.post<any>(
        url,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  UpdateWhatsappTemplateMasterStatusInActive(tenantId: number, templateId:number): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.MARK_WHATSAPP_TEMPLATE_INACTIVE
      .replace('{tenant_id}', tenantId.toString())
      .replace('{template_id}', templateId.toString());
    return this.http.post<any>(
        url,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }   

  CreateWhatsappTemplate(ownership:OwnershipLevel, payload:CreateWhatsappTemplate, tenantId:number, franchiseGroupId:number): Observable<any> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.CREATE_COMPANY_WHATSAPP_TEMPLATE;
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.CREATE_FRANCHISE_WHATSAPP_TEMPLATE
          .replace('{franchise_group_id}', franchiseGroupId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.CREATE_WHATSAPP_TEMPLATE
          .replace('{tenant_id}', tenantId.toString());
        break;
      default:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.CREATE_WHATSAPP_TEMPLATE
          .replace('{tenant_id}', tenantId.toString());
        break;
    }
    return this.http.post(url,payload, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  UpdateWhatsappTemplate(ownership:OwnershipLevel, templateId:number, updatePayload:UpdateWhatsAppTemplate, tenantId:number, franchiseGroupId:number): Observable<any> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.UPDATE_COMPANY_WHATSAPP_TEMPLATE
          .replace('{template_id}', templateId.toString());
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.UPDATE_FRANCHISE_WHATSAPP_TEMPLATE
          .replace('{franchise_group_id}', franchiseGroupId.toString())
          .replace('{template_id}', templateId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.UPDATE_WHATSAPP_TEMPLATE
          .replace('{tenant_id}', tenantId.toString())
          .replace('{template_id}', templateId.toString());
        break;
      default:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.UPDATE_WHATSAPP_TEMPLATE
          .replace('{tenant_id}', tenantId.toString())
          .replace('{template_id}', templateId.toString());
        break;
    }
    return this.http.put(url, updatePayload, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  getWhatsappTemplatesByOwnership(ownership:OwnershipLevel, tenantId:number, franchiseGroupId:number): Observable<ListWhatsAppTemplateMaster> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_COMPANY_WHATSAPP_TEMPLATES;
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_FRANCHISE_WHATSAPP_TEMPLATES
          .replace('{franchise_group_id}', franchiseGroupId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_WHATSAPP_TEMPLATES
          .replace('{tenant_id}', tenantId.toString());
        break;
      default:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_WHATSAPP_TEMPLATES
          .replace('{tenant_id}', tenantId.toString());
        break;
    }
    return this.http.get(url, {
      headers: this.httpOptions.headers
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }


  GetWhatsAppTemplateMasterByOwnership(ownership:OwnershipLevel, templateId:number,franchiseGroupId:number,tenantId:number): Observable<WhatsAppTemplateMaster> {
    let url="";
    switch (ownership) {
      case OwnershipLevel.Company:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_COMPANY_WHATSAPP_TEMPLATE_BY_ID
          .replace('{template_id}', templateId.toString());
        break;
      case OwnershipLevel.Franchise:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_FRANCHISE_WHATSAPP_TEMPLATE_BY_ID
          .replace('{franchise_group_id}', franchiseGroupId.toString())
          .replace('{template_id}', templateId.toString());
        break;
      case OwnershipLevel.Tenant:
        url = environment.BASE_URL + CONST_URL_SEGEMENTS.NOTIFICATIONS.GET_WHATSAPP_TEMPLATE_BY_ID
          .replace('{tenant_id}', tenantId.toString())
          .replace('{template_id}', templateId.toString());
        break;
      default:
        break;
    }
    return this.http.get<WhatsAppTemplateMaster>(url,this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

}
